import React from 'react';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import TableFilterInput from '../../../../components/_table/TableFilterInput';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import { setDateFormat } from '../../../../lib/moment';
import Anchor from '../../../../components/link/Anchor';
import { setDash } from '../../../../lib/common';
import OpenBrandProductList from '../../../../containers/app/common/OpenBrandProductList';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { COUPON_BRAND_LINK_PRODUCT_STATUS_LIST } from '../../../../constants/service/app/couponConstants';

/**
 *  쿠폰에 연결된 브랜드 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const {
    isFilter,
    filterOption,
    onFilter,
    toggleModal,
    discountAmount,
    discountType,
    maxDiscountPrice,
    minimumPurchasePrice,
    exclude24k,
  } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} filterValue={filterOption.storeId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드 ID 검색'}
          option={filterOption.storeId}
          confirm={confirm}
          onFilter={(storeId) => onFilter({ storeId })}
        />
      ),
      render: (value) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} filterValue={filterOption.storeName} />,
      dataIndex: 'storeName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드명 검색'}
          option={filterOption.storeName}
          confirm={confirm}
          onFilter={(storeName) => onFilter({ storeName })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'판매/품절 상품 수'} />,
      dataIndex: 'saleSoldOutProductCount',
      render: (value, record) => (
        <OpenBrandProductList
          text={value}
          productStatusList={COUPON_BRAND_LINK_PRODUCT_STATUS_LIST}
          storeId={record.id}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'적용가능 상품 수'} />,
      dataIndex: 'couponApplyAvailableProductCount',
      render: (value, record) => (
        <Anchor
          text={`${value}(${
            record.saleSoldOutProductCount > 0 ? ((value / record.saleSoldOutProductCount) * 100).toFixed(1) : '0'
          }%)`}
          isUnderLine
          color="primary"
          onClick={() =>
            toggleModal({
              name: 'couponApplyAvailableProductListModal',
              value: true,
              data: {
                listData: {
                  list: [],
                  pagination: LIST_PAGINATION_MODEL,
                },
                storeId: record.id,
                minimumPurchasePrice,
                discountAmount,
                discountType,
                maxDiscountPrice,
                exclude24k,
              },
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상점 티어'} />,
      dataIndex: 'storeTier',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'입점 일자'} />,
      dataIndex: 'entryDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
